import React, { memo } from 'react'
import Play from '../../../../Icon/icons/Play/index'

/**
 * Video-tile grid on the results step.
 *
 * Structural minimum of the document shape — fields actually read at
 * the legacy call site (CreatePlaylistModal.tsx:1221-1247). TODO:
 * replace with the named type exported from `./usePlaylistGeneration`
 * once it surfaces one publicly.
 */
export interface ResultsDocument {
  componentId: string
  title: string
  contentType?: string
  content?: { contentType?: string }
}

export interface ResultsVideoGridProps {
  documents: readonly ResultsDocument[]
  /** Re-imported from `./usePlaylistGeneration`; passed through to keep the
   *  grid decoupled from the generation hook's internals. */
  getDocumentThumbnail: (doc: ResultsDocument) => string | null
}

function ResultsVideoGridBase ({
  documents,
  getDocumentThumbnail,
}: ResultsVideoGridProps) {
  return (
    <div className="create-playlist-modal__results-grid">
      {documents.map((doc) => {
        const thumb = getDocumentThumbnail(doc) || ''
        const contentType = doc.contentType || doc.content?.contentType || ''
        return (
          <div
            key={doc.componentId}
            className="create-playlist-modal__video-card"
          >
            <div className="create-playlist-modal__video-thumb">
              {thumb ? (
                <img src={thumb} alt={doc.title} loading="lazy" />
              ) : (
                <div className="create-playlist-modal__video-thumb-placeholder">
                  <Play />
                </div>
              )}
            </div>
            <div className="create-playlist-modal__video-card-content">
              <span className="create-playlist-modal__video-title">{doc.title}</span>
              {contentType ? (
                <span className="create-playlist-modal__video-tags">
                  {contentType}
                </span>
              ) : null}
            </div>
          </div>
        )
      })}
    </div>
  )
}

const ResultsVideoGrid = memo(ResultsVideoGridBase)
ResultsVideoGrid.displayName = 'ResultsVideoGrid'
export default ResultsVideoGrid
